import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"min-width":"950px"}
}
const _hoisted_2 = { class: "modal-content px-10 py-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mb-10 pb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "fs-1" }, "Excluded List")
  ])
], -1)
const _hoisted_4 = { class: "pt-5" }
const _hoisted_5 = { class: "text-end mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-7 mb-7" }, null, -1)
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-2 table-hover" }
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_13 = { class: "text-center" }

import { useI18n } from "vue-i18n";
import { ref, inject } from "vue";
import { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
// import ToolServices from "../services/ToolServices";
import { hideModal, showModal } from "@/core/helpers/dom";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExcludeList',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = useI18n();
const isLoading = ref(false);
const ExcludelistCreateRef = ref(null);
const excludeList = ref<any>([]);
const configData = ref<any>({});
const openConfirmBox = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);



const formData = ref<any>({
  accountNumbers: "",
});

const updateExcludedList = async () => {
  try {
    await SystemService.putExcludeEquityBelowCredit(configData.value);
    fetchData();
  } catch (error) {
    MsgPrompt.error(t("tip.submitError"));
  }
};

const addItem = async () => {
  isLoading.value = true;

  const newItems = formData.value.accountNumbers.split(",").map(Number);
  excludeList.value = [...excludeList.value, ...newItems];
  configData.value["value"] = excludeList.value;
  updateExcludedList();

  formData.value.accountNumbers = "";
};

const deleteItem = async (item: any) => {
  isLoading.value = true;

  excludeList.value = excludeList.value.filter((i) => i !== item);
  configData.value["value"] = excludeList.value;
  updateExcludedList();
};

const openConfirmPanel = (item: any) => {
  openConfirmBox?.(() => deleteItem(item), void 0, {
    confirmTitle: "Delete Account",
    confirmText: "Confirm to delete this account - " + item,
  });
};

const fetchData = async () => {
  isLoading.value = true;

  try {
    configData.value = await SystemService.getExcludeEquityBelowCredit();

    excludeList.value = configData.value["value"];
  } catch (error) {
    console.log(error);
  }

  isLoading.value = false;
};

const show = () => {
  fetchData();
  showModal(ExcludelistCreateRef.value);
};

const close = () => {
  hideModal(ExcludelistCreateRef.value);
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "ExcludelistCreateRef",
    ref: ExcludelistCreateRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: formData.value.accountNumbers,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.accountNumbers) = $event)),
            placeholder: "Account Numbers ( Seperate By ' , ' )",
            type: "textarea",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "success",
              disable: isLoading.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (addItem()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
              ]),
              _: 1
            }, 8, ["disable"])
          ])
        ]),
        _hoisted_6,
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_8, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && excludeList.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excludeList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item), 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          onClick: ($event: any) => (openConfirmPanel(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ])
  ], 512))
}
}

})